module.exports = "<div style=\"z-index:-1\" class=\"maximize frameOverlay\"></div>"


//////////////////
// WEBPACK FOOTER
// ./src/view/frame-view.component.html
// module id = 978
// module chunks = 0